<template>
  <div class="report-link">
    <div @click.stop @click="reportCommunity()">
      <span>{{ $t('community.reportCommunity.reportText') }}</span>
    </div>
    <modal-confirm @click.stop
                   class="confirm-report"
                   @confirm="report()"
                   @close="closeModal()"
                   :cancel="$t('community.reportCommunity.back')"
                   :confirm="$t('community.reportCommunity.report')"
                   :title="$t('community.reportCommunity.reportACommunity')"
                   :message="$t('community.reportCommunity.reportConfirmation')"
                   :show-modal="showModal"
    />
  </div>
</template>

<script>
import ModalConfirm from '@/components/shared/ModalConfirm'

export default {
  name: 'ReportCommunityModal',
  components: { ModalConfirm },
  props: {
    communityId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    reportCommunity() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    async report() {
      let message = this.$t('community.reportCommunity.sentToCAnnect')
      let success = await this.$store.dispatch('reportCommunity', this.communityId)
      if (success) {
        this.showModal = false
        this.$toasted.global.success(message)
      }
    }
  }
}

</script>

<style scoped lang="scss">
.report-link {
  width: 100%;

  .link {
    color: $primary-color;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -ms-flex-pack: start;
    justify-content: flex-start;
    align-items: center;
    padding: 4px 12px;

    &:hover {
      cursor: pointer;
      background-color: $primary-color;
      color: white;
    }
  }
}
</style>
